import "../vendors/ReadMore.js";

declare global {
    interface Window {
        $readMoreJS: any;
    }
}

export default class ReadMoreMobile {
    readMoreMobileWrapper: HTMLElement;

    constructor() {
        this.readMoreMobileWrapper = document.querySelector('.read-more-mobile');
    }

    init() {
        if (this.readMoreMobileWrapper !== null) {
            const tabletAndLarger = window.matchMedia('(min-width: 768px)');

            if (!tabletAndLarger.matches) {
                window.$readMoreJS.init({
                    target: '.read-more-mobile',  // gets all targets - no need to loop
                    toggle: false,                 // If true, user can toggle between 'read more' and 'read less'. Default: true
                    moreLink: '...read more',    // The text of 'Read more' link. Default: 'read more ...'
                    lessLink: 'read less'         // The text of 'Read less' link. Default: 'read less'
                });
            }

        }
    }
}